import React from 'react';
import Header from './../inc/Header';
import Footer from './../inc/Footer';
import Loader from './../inc/Loader';
import Menu from './../inc/Menu';
import MenuToggleBtn from './../inc/MenuToggleBtn';

import Hero from './Hero';
import TeamMembers from './../Team/TeamMembers';
import Values from './Values';
import Services from './Services';
import Services2 from './Services2';
import Awards from './Awards';
import Press from './Press';
import Published from './Published';
import Catalogues from './Catalogues';

import { fetchMenu } from "./../../actions/menuActionCreators";
import { fetchPage } from "./../../actions/pageActionCreators";
import { fetchOptions } from "./../../actions/optionActionCreators";
import { fetchProjects } from "./../../actions/projectActionCreators";
import { fetchAwards } from "./../../actions/awardActionCreators";
import { fetchPress } from "./../../actions/pressActionCreators";
import { fetchPosts } from "./../../actions/postActionCreators";
import ReactFullpage from '@fullpage/react-fullpage';
import ScrollToTop from './../inc/ScrollToTop';

const page_id = '10';

class Index extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			pageLoading: true
		}
	}

	componentWillMount(){
		let before = performance.now();
		let _this = this;
		Promise.all([
			this.props.dispatch(fetchMenu('menu')),
			this.props.dispatch(fetchPage(page_id)),
			this.props.dispatch(fetchProjects()),
			this.props.dispatch(fetchOptions()),
			this.props.dispatch(fetchPosts('ml_published')),
			this.props.dispatch(fetchAwards()),
			this.props.dispatch(fetchPress()),
			this.props.dispatch(fetchPosts('ml_team')),
		]).then(() => {
			let after = performance.now();
			let diff = after-before;
			let media_length = process.env.REACT_APP_ANIMATION_DURATION;
			if(diff < media_length){
				setTimeout(() => {
					_this.setState({
						pageLoading: false
					})
				},(media_length - diff))
			}else{
				_this.setState({
					pageLoading: false
				})
			}
			
		});
	}

	render() {
		let _this = this;
		let { menu } = this.props.menu;
		let {ml_published, ml_team} = this.props.posts.data;
		const Fullpage = () => (
			<ReactFullpage
				// anchors={['hero', 'values', 'services, 'quote', 'awards', 'press', 'downloads', 'publicity', 'footer']}
				scrollOverflow={true}
				licenseKey={process.env.REACT_APP_FULLPAGE_LICENSE}
				offsetSections={true}
				responsiveWidth={process.env.REACT_APP_FULLPAGE_BREAKPOINT}
				scrollingSpeed={500}
                css3={true}
				controlArrows={false}
				// afterLoad={
                //     function (origin, destination, direction) {
                //         var theme = destination.item.dataset ? destination.item.dataset.hammenu : false;
                //         let header = document.querySelector('header');
				// 		const btmarw = document.querySelector('.btn--bottom-arw');
                        
                //     }
                // }
                onLeave={
                    function (origin, destination, direction) {
						let logo = document.querySelector('.mole-logo');
						let menu = document.querySelector('.btn--menu');
						let menuBtn = document.querySelector('header .btn-menu--label');
						
                    	(destination.item.dataset.logo) ? logo.classList.add('hidden') : logo.classList.remove('hidden');
						(destination.isLast) ? menuBtn.classList.add('only-') : menuBtn.classList.remove('only-');

						// hide slide prev btn
						let slideP = destination.item.querySelector('.fp-prev');
						let slideL = destination.item.querySelector('.fp-next');
						if(slideP) { slideP.classList.add('disabled') }

						if(slideL){
							if(slideL.classList.contains('disabled')){
								slideP.classList.remove('disabled');
							}
						}
                    }
				}
				afterSlideLoad={
					function(section, origin, destination, direction){
						let slideP = destination.item.closest('section').querySelector('.fp-prev');
						let slideL = destination.item.closest('section').querySelector('.fp-next');

						(destination.isFirst) ? slideP.classList.add('disabled') : slideP.classList.remove('disabled');
						(destination.isLast) ? slideL.classList.add('disabled') : slideL.classList.remove('disabled');

					}
				}
				render={({ state, fullpageApi }) => {
					

					return (
						<ReactFullpage.Wrapper>
                			<MenuToggleBtn {..._this.props} fullpageApi={fullpageApi} />
                            <Hero {..._this.props} fullpageApi={fullpageApi} page_id={page_id} />
                            {/* <Values {..._this.props} fullpageApi={fullpageApi}/> */}
                            {/* <Services {..._this.props} fullpageApi={fullpageApi}/> */}
                            {/* <Services2 {..._this.props} fullpageApi={fullpageApi}/> */}
                            <Awards {..._this.props} fullpageApi={fullpageApi}/>
                            <Press {..._this.props} fullpageApi={fullpageApi}/>
                            <Catalogues {..._this.props} fullpageApi={fullpageApi}/>   
                            <Published {..._this.props} fullpageApi={fullpageApi}/>
							<Footer/>
						</ReactFullpage.Wrapper>
					)
				}}
			/>
		);

		return (
			<React.Fragment>
				{this.state.pageLoading &&
					<Loader />
				} 
				<ScrollToTop />
				<Header {..._this.props}/>
				<main className="mole__about" >
					{/* <Fullpage {..._this.props} /> */}
					<Hero {..._this.props} page_id={page_id}/>
					{ml_team &&
						<TeamMembers {..._this.props} members={ml_team} page_id={page_id}/>
					}
					{/* <Values {..._this.props} page_id={page_id}/>
					<Services2 {..._this.props} page_id={page_id}/> */}
					<Awards {..._this.props}/>
					<Press {..._this.props}/>
					<Published {..._this.props} ml_published={ml_published}/>
					<Catalogues {..._this.props} page_id={page_id}/>   
				</main>
				{!this.state.pageLoading &&
					<Menu {..._this.props}/>
				}
				<Footer {..._this.props}/>
			</React.Fragment>
		);
	}
}

export default Index;


// WEBPACK FOOTER //
// ./src/components/About/_index.js